var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5273.1 2400.1v-2c0-2.8-5-4-9.7-4s-9.7 1.3-9.7 4v2c0 1.8 0.7 3.6 2 4.9l5 4.9c0.3 0.3 0.4 0.6 0.4 1v6.4c0 0.4 0.2 0.7 0.6 0.8l2.9 0.9c0.5 0.1 1-0.2 1-0.8v-7.2c0-0.4 0.2-0.7 0.4-1l5.1-5C5272.4 2403.7 5273.1 2401.9 5273.1 2400.1zM5263.4 2400c-4.8 0-7.4-1.3-7.5-1.8v0c0.1-0.5 2.7-1.8 7.5-1.8 4.8 0 7.3 1.3 7.5 1.8C5270.7 2398.7 5268.2 2400 5263.4 2400z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5268.4 2410.3c-0.6 0-1 0.4-1 1 0 0.6 0.4 1 1 1h4.3c0.6 0 1-0.4 1-1 0-0.6-0.4-1-1-1H5268.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5272.7 2413.7h-4.3c-0.6 0-1 0.4-1 1 0 0.6 0.4 1 1 1h4.3c0.6 0 1-0.4 1-1C5273.7 2414.1 5273.3 2413.7 5272.7 2413.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5272.7 2417h-4.3c-0.6 0-1 0.4-1 1 0 0.6 0.4 1 1 1h4.3c0.6 0 1-0.4 1-1C5273.7 2417.5 5273.3 2417 5272.7 2417z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6 62.8H12.4c-5.5 0-9.9 4.5-9.9 9.9v11.2c0 5.5 4.5 9.9 9.9 9.9h75.1c5.5 0 9.9-4.5 9.9-9.9V72.7C97.5 67.3 93 62.8 87.6 62.8zM92 83.9c0 2.5-2 4.5-4.5 4.5H12.4c-2.5 0-4.5-2-4.5-4.5V72.7c0-2.5 2-4.5 4.5-4.5h75.1c2.5 0 4.5 2 4.5 4.5V83.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73H13.6c-0.5 0-0.9 0.4-0.9 0.9v8.9c0 0.5 0.4 0.9 0.9 0.9H66c0.5 0 0.9-0.4 0.9-0.9v-8.9C66.9 73.4 66.5 73 66 73z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56.4c13.9 0 25.1-11.3 25.1-25.1C75.1 17.4 63.9 6.1 50 6.1S24.9 17.4 24.9 31.2C24.9 45.1 36.1 56.4 50 56.4zM47.3 17.9c0-1.5 1.2-2.7 2.7-2.7s2.7 1.2 2.7 2.7v10.6h7.9c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7H50c-1.5 0-2.7-1.2-2.7-2.7V17.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/suspend.f57d8d26a4884aef83a5183a4acb3dbf.svg";
export { ForwardRef as ReactComponent };